<template>
	<search-input alias="Categoria" v-model="form.category_id.value" :displayedValue="form.category_description.value"
		:form="form" :name="'category_id'" @search="searchCategory($event)" :searchResult="searchCategoryResults.results"
		:isLoading="searchCategoryResults.isLoading" @selected="setCategory($event)">
		<search-input-option v-for="(row, index) in searchCategoryResults.results.data" :key="index" :index="index"
			@click="setCategory(row)">
			<div>
				{{ row.description }}
			</div>
		</search-input-option>
	</search-input>
</template>

<script>
import Form from "../mixins/Form";

export default {
	props: {
		value: {},
		category_description: {},
		name: {},
	},

	data: function () {
		return {
			form: new Form({
				category_id: {
					alias: "Categoria",

				},

				category_description: {},
			}),

			searchCategoryResults: {
				results: {},
				isLoading: false,
			},
		};
	},

	created() {
		this.form.category_id.value = this.value;
		this.form.category_description.value = this.category_description || this.name;
	},

	watch: {
		name(newValue) {
			this.form.category_description.value = newValue;
		},
	},

	computed: {
		category_id() {
			return this.form.category_id.value;
		},


	},

	watch: {
		category_id(newValue) {
			this.$emit("input", newValue);
		},

		category_description: function (newValue, oldValue) {
			this.form.category_description.value = this.category_description;
		},

		value: function (newValue, oldValue) {
			this.form.category_id.value = newValue;
		},
	},

	methods: {
		searchCategory(search) {
			this.searchCategoryResults.isLoading = true;

			axios
				.post(process.env.BASE_URL + "api/product/category/select?page=" + search.page, {
					description: search.text,

				})
				.then(response => {
					this.searchCategoryResults.results = response.data;

					this.searchCategoryResults.isLoading = false;
				})
				.catch(error => {
					console.log(error);
					this.error = error;
				});
		},

		setCategory(category) {
			this.selectedCategory = category;

			this.form.category_id.value = category.id;

			this.form.category_description.value = category.description;

			this.$emit("categorySelected", category);
			this.$emit("selected", category);
		},
		clear() {

			this.form.category_id.value = ''
			this.form.category_description.value = ''

		}
	},
};
</script>

<style></style>